export const Conditions = {
  monteSpace: { lat: 34.71034709736502, lng: 135.22541341979556 },
  freeSpace: { lat: 34.71195, lng: 135.22754 },
} as const;

export type ConditionsType = (typeof Conditions)[keyof typeof Conditions];
